import gql from 'graphql-tag';

import { UserProfileFragment } from './fragments/MyProfileFragment';

export const query = gql`
  query MyProfileQuery {
    myProfile {
      id
      userDetails {
        ...UserProfileFragment
      }
    }
  }
  ${UserProfileFragment}
`;
